const API_BASE_URL = import.meta.env.VITE_API_URL;

export async function saveDesignWithRating(design, isPositive, userEmail) {
  // Omit id to ensure a new design is created
  const { id, ...designWithoutId } = design;
  const designWithRating = {
    ...designWithoutId,
    isRandomized: true,
    createdBy: userEmail,
    name: "Randomized Review",
    description: isPositive ? "Positive feedback" : "Negative feedback",
    ratings: {
      score: isPositive ? 10 : 1,
      feedback: isPositive ? "Positive feedback" : "Negative feedback",
      ratedAt: new Date().toISOString(),
      ratedBy: userEmail
    }
  };

  // Get JWT token from localStorage
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}/api/lamp-designs`, {
    method: 'POST',
    headers,
    body: JSON.stringify(designWithRating),
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to save design');
  }

  const savedDesign = await response.json();
  if (!savedDesign.id) {
    throw new Error('No design ID returned from server');
  }

  return savedDesign;
}

export async function updateDesignRating(designId, isPositive, userEmail) {
  const rating = {
    score: isPositive ? 10 : 1,
    feedback: isPositive ? "Positive feedback" : "Negative feedback",
    ratedAt: new Date().toISOString(),
    ratedBy: userEmail
  };

  const description = isPositive ? "Positive feedback" : "Negative feedback";

  // Get JWT token from localStorage
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}/api/lamp-designs/${designId}/rate`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ ratings: rating, description: description })
  });

  if (!response.ok) {
    throw new Error('Failed to save rating');
  }

  return response.json();
} 